<div class="content-desktop">
  <div class="content-desktop__image-qr">
    <div class="content-desktop__image-qr__qr">
      <img [src]="qr" alt="" class="content-desktop__image-qr__qr__img" />
    </div>
  </div>
  <ol start="1">
    <li>
      <span>
        {{
          text1 ||
            "Scan the QR code or enter the TOTP Key into the TOTP Authenticator of your choice."
        }}
      </span>
      <metodh-auth></metodh-auth>
    </li>
    <li>
      {{ text2 || "Enter the generated TOTP Code into the input to the left." }}
    </li>
    <li>Click {{ tex3 || "“Check”." }}</li>
  </ol>
</div>
